import React from 'react';
import { useToolbarContext } from '../../hooks/use-toolbar-context';
import CopyBtn from './copy-btn';
import DeleteBtn from './delete-btn';
import LockBtn from './lock-btn';
import SortBtn from './sort-btn';
import TextBrushBtn from './text-brush-btn';
import './toolbar.less';

export enum ToolBarType {
    TEXT_BRUSH = 'textBrush',
    LOCK = 'lock',
    SORT = 'sort',
    COPY = 'copy',
    DELETE = 'delete',
}

const ToolBar = ({ toolBar = Object.values(ToolBarType) }: { toolBar?: string[] }) => {
    const {
        hideCopyBtn,
        id,
        textLayerId,
        lock,
        style,
        onCopyBrush,
        onApplyBrush,
        onLock,
        onSort,
        onCopy,
        onDelete,
        beforeDelete,
    } = useToolbarContext();

    return (
        <div className="c-header-toolbar-btns" style={style}>
            {toolBar.map((key) => {
                switch (key) {
                    case ToolBarType.TEXT_BRUSH:
                        return textLayerId ? (
                            <TextBrushBtn
                                key="textBrushBtn"
                                id={textLayerId}
                                onCopyBrush={onCopyBrush}
                                onApplyBrush={onApplyBrush}
                            />
                        ) : null;
                    case ToolBarType.LOCK:
                        return <LockBtn key="lockBtn" id={id} lock={lock} onLock={onLock} />;
                    case ToolBarType.SORT:
                        return <SortBtn key="sortBtn" id={id} onSort={onSort} />;
                    case ToolBarType.COPY:
                        return hideCopyBtn ? null : <CopyBtn key="copyBtn" id={id} disable={lock} onCopy={onCopy} />;
                    case ToolBarType.DELETE:
                        return (
                            <DeleteBtn
                                key="deleteBtn"
                                id={id}
                                disable={lock}
                                onDelete={onDelete}
                                beforeDelete={beforeDelete}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </div>
    );
};

export default React.memo(ToolBar);
